import { useContextState } from "../../../../../../hooks/theme"


const useStyles = () => {
    const { colors } = useContextState()
    return {
        clean: (disable:boolean) => ({
            padding: '6px',
            '& .MuiSvgIcon-root': {
                fontSize: '1em',
            },
            '&.add': {
                color: disable ? '' : colors.color4,
                fontSize: '2rem',
                padding: '0px',
                paddingRight: '2px',
            },
        }),
        container: {
            display: 'flex',
            //alignItems: 'center',
            justifyContent: 'space-between',
            gap: 3,
            flexWrap: 'wrap',
            marginTop: 2
        },
        input: (mb:boolean) => ({
            flex: '1 1 200px',
            //mb: mb ? 3 : 0,
            //border:'1px solid red'
        })
    }
}

export { useStyles }
